import App from '@/App.vue';
import '@fortawesome/fontawesome-free/css/all.css';
import 'document-register-element';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import Vue from 'vue';
import vueCustomElement from 'vue-custom-element';
import { vuetify } from './plugins';
import store from './store';
import { i18n } from '@/plugins/i18n';
import { apiClient } from '@/plugins/api';
import '@/plugins/tooltip';
import VueScrollTo from 'vue-scrollto';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import 'pepjs';
import 'vue-resize/dist/vue-resize.css';
import VueResize from 'vue-resize';

Vue.use(VueResize);
Vue.use(vueCustomElement);
Vue.config.productionTip = false;

Vue.use(PerfectScrollbar);

Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

// @ts-ignore
Vue.customElement('creative-configurator', new Vue({
  store,
  // @ts-ignore
  vuetify,
  i18n,
  apiClient,
  props: ['configuration', 'events'],
  created() {
    if (this.configuration) {
      const confStr = this.configuration.split('\'').join('\"');
      const configuration = JSON.parse(confStr);
      this.$store.commit('setConfiguration', configuration);
    }
  },
  watch: {
    events: function (val) {
      this.$store.commit('setEvents', val);
    },
  },
  render: (h) => h(App),
}).$options);
